import main from '@account/pages/main.vue';
export default [
  {
    path: 'account',
    name: 'account',
    component: main,
    redirect: 'account/personal',
    meta: { title: '账户管理', auth: true },
    children: [
      {
        path: 'personal',
        name: 'account/personal',
        meta: { title: '个人信息', auth: true },
        component: () => import('@account/pages/personal/index.vue'),
      },
      {
        path: 'enterprise',
        name: 'account/enterprise',
        meta: { title: '企业信息', auth: true },
        component: () => import('@account/pages/enterprise/index.vue'),
      },
      {
        path: 'role',
        name: 'account/role',
        meta: { title: '角色权限', auth: true },
        component: () => import('@account/pages/role/index.vue'),
      },
    ],
  },
  {
    path: 'account/enterprise/edit',
    name: 'account/enterprise/edit',
    meta: { title: '修改企业信息', auth: true },
    component: () => import('@account/pages/enterprise/edit.vue'),
    children: [
      {
        path: 'name',
        name: 'account/enterprise/edit/name',
        meta: { title: '修改公司名称', auth: true },
        component: () => import('@account/pages/enterprise/edit.vue'),
      },
    ],
  },
  {
    path: 'account/role/edit/member',
    name: 'account/role/edit/member',
    meta: { title: '修改', auth: true },
    component: () => import('@account/pages/role/edit.vue'),
  },
  {
    path: 'account/role/edit',
    name: 'account/role/edit',
    meta: { title: '编辑角色', auth: true },
    component: () => import('@account/pages/role/edit.vue'),
  },
];
